import React, { useState } from 'react';
import { Modal, Textarea } from '@mantine/core';
import { Button } from '../../../../components/Button';
import navyModal from '../../../../components/Modal/navy-modal.module.scss';
import type { TenantView } from '../../../../services/tenants/tenants.service';
import classes from './header-edit-modal.module.scss';

type EditHeaderModalProps = {
  tenant: TenantView | null;
  isSaving: boolean;
  onClose: () => void;
  onSubmit: (tenant: TenantView, header: string) => void;
};

export const EditHeaderModal: React.FC<EditHeaderModalProps> = ({
  tenant,
  isSaving,
  onClose,
  onSubmit,
}) => {
  const [header, setHeader] = useState<string>(tenant?.header ?? '');

  React.useEffect(() => {
    if (tenant) setHeader(tenant.header ?? '');
  }, [tenant]);

  if (!tenant) return null;

  return (
    <Modal
      opened={tenant != null}
      onClose={onClose}
      onContextMenu={(event) => event.preventDefault()}
      title={`עדכון כותרת — ${tenant.companyName}`}
      centered
      radius="md"
      classNames={{ root: navyModal.root }}
      withinPortal
      closeOnClickOutside={false}
      trapFocus={false}
      closeButtonProps={{ 'data-testid': 'header-edit-close' } as Record<string, string>}
    >
      <Textarea
        data-testid="header-edit-input"
        label="כותרת"
        value={header}
        onChange={(event) => setHeader(event.currentTarget.value)}
        autosize
        minRows={4}
        maxLength={2000}
        size="md"
        radius="md"
      />
      <div className={classes.modalActions}>
        <Button variant="cancel" onClick={onClose} disabled={isSaving} dataTestId="header-edit-cancel">
          ביטול
        </Button>
        <Button
          variant="save"
          onClick={() => onSubmit(tenant, header)}
          disabled={isSaving}
          loading={isSaving}
          loadingLabel="שומר..."
          dataTestId="header-edit-save"
        >
          שמור
        </Button>
      </div>
    </Modal>
  );
};
